exports.components = {
  "component---src-pages-games-js": () => import("./../../../src/pages/games.js" /* webpackChunkName: "component---src-pages-games-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-games-page-js": () => import("./../../../src/templates/gamesPage.js" /* webpackChunkName: "component---src-templates-games-page-js" */),
  "component---src-templates-index-page-js": () => import("./../../../src/templates/indexPage.js" /* webpackChunkName: "component---src-templates-index-page-js" */)
}

